import { FC, useMemo } from 'react'

import { Breakpoints } from '@hhgtech/hhg-components'
import { Box, Stack } from '@mantine/core'
import { useIntl } from 'react-intl'

import { getHelloSitesUrl } from 'api/utils/paths'
import FeatureCard from 'components/molecules/FeatureCard'
import { SpotlightCard } from 'components/pages/spotlight/spotlightCard'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { basePath } from 'interfaces/constants'
import { SpotlightSummary } from 'interfaces/types'

import {
  StyledSpotlightsBadgeIcon,
  StyledSpotlightsItem,
} from './HomeSpotlight.styled'
import CarouselCard from '../CarouselCardV2/'

export type HomeSpotlightProps = { spotlights: SpotlightSummary[] }
export const HomeSpotlight: FC<HomeSpotlightProps> = (props) => {
  const { spotlights } = props
  const { formatMessage: f } = useIntl()
  const { locale } = useRouterExtend()

  const currentDomain = useMemo(() => getHelloSitesUrl(locale), [locale])

  if (!spotlights?.length) {
    return null
  }

  return (
    <>
      <FeatureCard url="/spotlight/" color="blue">
        <FeatureCard.SectionName
          icon={<StyledSpotlightsBadgeIcon />}
          data-event-category="Spotlight"
          data-event-action="See All Click"
          data-event-label={`${currentDomain}${basePath}/spotlight`}
        >
          {f({
            id: 'home.recommendSpotlight',
            defaultMessage: 'Spotlight',
          })}
        </FeatureCard.SectionName>
        <FeatureCard.Heading>
          {f({
            id: 'home.spotlight.title',
            defaultMessage:
              'Khám phá những chiến dịch, chủ đề nổi bật từ hellobacsi',
          })}
        </FeatureCard.Heading>
        <FeatureCard.Content>
          <CarouselCard
            slideSize="auto"
            slideGap={18}
            align={'start'}
            autoplay
            breakpoints={[
              {
                maxWidth: Breakpoints.BREAK_POINT_TABLET,
                slideSize: '60%',
                slideGap: 16,
              },
            ]}
            styles={(theme) => ({
              viewport: {
                paddingLeft: 16,
                paddingRight: 16,
                [theme.fn.largerThan('sm')]: {
                  paddingLeft: 48,
                  paddingRight: 48,
                },
              },
            })}
          >
            <Stack spacing={24}>
              <Box
                sx={(theme) => ({
                  marginLeft: -16,
                  marginRight: -16,
                  [theme.fn.largerThan('sm')]: {
                    marginLeft: -48,
                    marginRight: -48,
                  },
                })}
              >
                <CarouselCard.Body>
                  {spotlights.map((item, index) => (
                    <CarouselCard.Slide key={String(index)}>
                      <StyledSpotlightsItem>
                        <SpotlightCard
                          key={index}
                          index={index + 1}
                          spotlight={item}
                          cardsPerRow={9999999}
                          className="spotlight-card"
                          tracking={{
                            'data-event-category': 'Spotlight',
                            'data-event-action': 'Banners Click',
                            'data-event-label': `${currentDomain}${basePath}${item.permalink}`,
                          }}
                        />
                      </StyledSpotlightsItem>
                    </CarouselCard.Slide>
                  ))}
                </CarouselCard.Body>
              </Box>
              <Box
                sx={(theme) => ({
                  height: 1,
                  backgroundColor: '#fff',
                  [theme.fn.smallerThan('sm')]: {
                    display: 'none',
                  },
                })}
              />
              <CarouselCard.Footer>
                <FeatureCard.ViewAll
                  data-event-category="Spotlight"
                  data-event-action="See All Click"
                  data-event-label={`${currentDomain}${basePath}/spotlight`}
                >
                  {f({
                    id: 'home.spotlight.buttonViewAll',
                    defaultMessage: 'View all Spotlights',
                  })}
                </FeatureCard.ViewAll>
                <CarouselCard.Controls>
                  <CarouselCard.Control
                    direction="prev"
                    data-event-category="Spotlight"
                    data-event-action="See More Spotlight"
                    data-event-label={`${currentDomain}${basePath}`}
                  />
                  <CarouselCard.Control
                    direction="next"
                    ata-event-category="Spotlight"
                    data-event-action="See More Spotlight"
                    data-event-label={`${currentDomain}${basePath}`}
                  />
                </CarouselCard.Controls>
              </CarouselCard.Footer>
            </Stack>
          </CarouselCard>
        </FeatureCard.Content>
        <FeatureCard.ViewAll
          data-event-category="Spotlight"
          data-event-action="See All Click"
          data-event-label={`${currentDomain}${basePath}/spotlight`}
        >
          {f({
            id: 'home.spotlight.buttonViewAll',
            defaultMessage: 'View all Spotlights',
          })}
        </FeatureCard.ViewAll>
      </FeatureCard>
    </>
  )
}
